export const GET_PENDING_AMOUNT_LIST = `api/v1/get-patient-pending-payments`;
